import { render, staticRenderFns } from "./MeInsuranceList.vue?vue&type=template&id=2f81ec4b&"
import script from "./MeInsuranceList.vue?vue&type=script&lang=js&"
export * from "./MeInsuranceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports